// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jw-title-clips .jw-title-clip{padding-inline-start:0}.jw-title-clips__heading{-webkit-font-smoothing:antialiased;font-family:Anton,Anton-Fallback,Impact;font-size:22px;font-weight:400;line-height:32px;letter-spacing:.02em;text-transform:uppercase;color:#fff}.jw-title-clips>.row>[class*=col-]{margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
